:host {
  display: block;
  --color: var(--l-color-text-tertiary);
}

.label {
  /* Inline padding aligns with dropdown-item's `0.375rem 0.5rem` so labels and
     items line up; extra top padding adds breathing room above each section. */
  padding: 0.375rem 0.5rem 0.125rem;
  font-size: 0.6875rem; /* 11px */
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  line-height: 1.4;
  color: var(--color);
  white-space: nowrap;
  user-select: none;
}
